import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "icon-square4",
  "use": "icon-square4-usage",
  "viewBox": "0 0 1024 1024",
  "content": "<symbol class=\"icon\" viewBox=\"0 0 1024 1024\" xmlns=\"http://www.w3.org/2000/svg\" id=\"icon-square4\"><defs><style></style></defs><path d=\"M64 64h896v896H64z\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol